import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import fieldNames from '../constants/field-names';

const { SimpleSelectField } = designSystem;

function LinkTypeField({ control, options, menuPlacement = 'auto', onChange }) {
  return (
    <SimpleSelectField
      name={fieldNames.LINK_TYPE}
      control={control}
      options={options}
      menuPlacement={menuPlacement}
      onChange={onChange}
    />
  );
}

LinkTypeField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  menuPlacement: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default LinkTypeField;
